import {View} from 'react-native';

import {Dialog, Text} from '~/components/controls';
import sy from '~/styles';
import InfoIcon from '~/images/md-icons/info/materialicons/24px.svg';
import PropTypes from 'prop-types';

const DamageNotAllowedDialog = ({onDismiss}) => {
  return (
    <Dialog
      visible={true}
      onDismiss={onDismiss}
      options={{noPaddingContent: true}}
      title="Schadewerkopdracht"
      titleIcon={<InfoIcon fill="#4a4a49" />}>
      <View style={[sy['py-4'], sy['gap-4']]}>
        <View style={[sy['px-6']]}>
          <Text>
            Schadekenmerk bij activiteit wordt niet toegestaan door LM.
          </Text>
        </View>
      </View>
    </Dialog>
  );
};
DamageNotAllowedDialog.propTypes = {
  onDismiss: PropTypes.any,
};


export default DamageNotAllowedDialog;
